import detectBrowserLanguage from 'detect-browser-language'
export const Languages = detectBrowserLanguage() || {}
export default Languages;
